"use client";

import React from "react";
import svgPaths from "@/assets/svg/svg-5s97axwnwx";
import { Loader2 } from "lucide-react";

export default function MobileProSection({
	onClick,
	isUpgrading,
}: {
	onClick?: () => void;
	isUpgrading?: boolean;
}) {
	return (
		<div
			className="bg-[#1a2c20] rounded-2xl mb-8"
			style={{ padding: "1rem" }}
		>
			<div className="flex items-start gap-4 mb-6">
				<div
					className="w-14 h-14 rounded-full flex items-center justify-center shrink-0"
					style={{
						background:
							"linear-gradient(90deg, rgba(101, 222, 158, 0.12), rgba(0, 0, 0, 0.05))",
					}}
				>
					<svg className="w-8 h-8" fill="none" viewBox="0 0 56 56">
						<path
							d={svgPaths.p26d12a20}
							fill="black"
							fillOpacity="0.05"
						/>
						<path
							d={svgPaths.p26d12a20}
							fill="#65DE9E"
							fillOpacity="0.12"
						/>
						<path d={svgPaths.p1c8f3080} fill="#A7FF5E" />
					</svg>
				</div>
				<div className="flex-1">
					<h2 className="text-white text-xl font-bold mb-2">
						Tax Lien Vest PRO
					</h2>
					<p className="text-[rgba(255,255,255,0.7)] text-sm leading-relaxed">
						Join Thousands of Smart Investors & Upgrade Your
						Property Research
					</p>
				</div>
			</div>

			<div className="backdrop-blur-md bg-[rgba(255,255,255,0.05)] border border-[rgba(255,255,255,0.25)] rounded-xl p-5">
				<p className="text-white text-center text-sm font-semibold mb-6">
					One-time Payment
				</p>

				<div className="mb-6">
					<p className="text-white text-xs font-semibold uppercase tracking-wider mb-4 opacity-80">
						With Pro You Unlock
					</p>

					<div className="flex flex-col gap-5">
						<div className="flex items-center gap-2">
							<svg
								className="w-4 h-4 shrink-0 opacity-80"
								fill="none"
								viewBox="0 0 16 16"
							>
								<path
									d={svgPaths.p10198100}
									stroke="#A7FF5E"
									strokeLinecap="round"
									strokeLinejoin="round"
									strokeWidth="1.33"
								/>
							</svg>
							<p className="text-white text-xs opacity-80">
								Authentic Parcel data
							</p>
						</div>

						<div className="flex items-center gap-2">
							<svg
								className="w-4 h-4 shrink-0 opacity-80"
								fill="none"
								viewBox="0 0 16 16"
							>
								<path
									d={svgPaths.p14e39e00}
									stroke="#A7FF5E"
									strokeLinecap="round"
									strokeLinejoin="round"
									strokeWidth="1.33"
								/>
							</svg>
							<p className="text-white text-xs opacity-80">
								Trusted Data Sources
							</p>
						</div>

						<div className="flex items-center gap-2">
							<svg
								className="w-4 h-4 shrink-0 opacity-80"
								fill="none"
								viewBox="0 0 16 16"
							>
								<path
									d={svgPaths.p2ab14700}
									stroke="#A7FF5E"
									strokeLinecap="round"
									strokeLinejoin="round"
									strokeWidth="1.33"
								/>
							</svg>
							<p className="text-white text-xs opacity-80">
								Pricing Data
							</p>
						</div>

						<div className="flex items-center gap-2">
							<svg
								className="w-4 h-4 shrink-0 opacity-80"
								fill="none"
								viewBox="0 0 16 16"
							>
								<path
									d={svgPaths.p2f430cf2}
									stroke="#A7FF5E"
									strokeLinecap="round"
									strokeLinejoin="round"
									strokeWidth="1.33"
								/>
							</svg>
							<p className="text-white text-xs opacity-80">
								Fast Property Insights
							</p>
						</div>

						<div className="flex items-center gap-2">
							<svg
								className="w-4 h-4 shrink-0 opacity-80"
								fill="none"
								viewBox="0 0 16 16"
							>
								<path
									d={svgPaths.p3d8d99e0}
									stroke="#A7FF5E"
									strokeLinecap="round"
									strokeLinejoin="round"
									strokeWidth="1.33"
								/>
							</svg>
							<p className="text-white text-xs opacity-80">
								Export Data to google maps
							</p>
						</div>
					</div>
				</div>

				<div className="border-t border-[rgba(255,255,255,0.1)] pt-5 mb-6">
					<div className="flex items-center gap-2 mb-2">
						<div className="w-2 h-2 rounded-full bg-[#A7FF5E] opacity-80"></div>
						<p className="text-white text-xs font-bold italic uppercase opacity-80">
							Live Right Now
						</p>
					</div>
					<div className="flex items-start gap-2">
						<svg
							className="w-4 h-4 shrink-0 opacity-80 mt-0.5"
							fill="none"
							viewBox="0 0 16 16"
						>
							<path
								d={svgPaths.p10198100}
								stroke="#CBF7A6"
								strokeLinecap="round"
								strokeLinejoin="round"
								strokeWidth="1.33"
							/>
						</svg>
						<p className="text-white text-xs opacity-80 flex-1">
							Owner information of more than 50,000 properties
							properties ready to export
						</p>
					</div>
				</div>

				<button
					onClick={onClick}
					disabled={isUpgrading}
					className="w-full bg-[#a7ff5e] text-[#12301b] rounded-full py-3.5 px-8 flex items-center justify-center gap-2 font-extrabold text-sm shadow-lg border border-[#dde3e9] disabled:opacity-70 disabled:cursor-not-allowed"
				>
					<svg
						className="w-6 h-6 shrink-0"
						fill="none"
						viewBox="0 0 24 24"
					>
						{isUpgrading ? (
							<foreignObject width="24" height="24">
								<div className="flex items-center justify-center w-full h-full">
									<Loader2 className="w-5 h-5 animate-spin" />
								</div>
							</foreignObject>
						) : (
							<path d={svgPaths.p21cafcf0} fill="#1C1B1F" />
						)}
					</svg>
					<span>
						{isUpgrading
							? "Redirecting..."
							: "Try Free for 14 days"}
					</span>
				</button>
			</div>
		</div>
	);
}
